import { AppContextType } from "../../../../context/AppContext";
import useAppContext from "../../../../hooks/useAppContext";
import { initialReducedIndividualState } from "../../../../static/initialState/commonInitialState/initialReducedIndividualState";
import { ReducedIndividualPersonType } from "../../../../static/types/commonTypes/reducedIndividualPersonType";
import ReducedIndividualPerson from "../../../commonComponents/ReducedIndividualPerson";

const FamilySituation = () => {

    const {

        typeFamilySituationData, setTypeFamilySituationData,

        reducedIndividualPerson, setReducedIndividualPerson,
        reducedIndividualPersonValidity, setReducedIndividualPersonValidity,
        reducedIndividualPersonChecked,setReducedIndividualPersonChecked,

    } = useAppContext() as AppContextType

    const updatePerson = (data: Partial<ReducedIndividualPersonType>) => setReducedIndividualPerson({...reducedIndividualPerson,...data})

    return (
        <div className="contenair my-4">
            <div className="row mb-3">
                <label htmlFor="typeFamilySituation" className="col-sm-auto col-form-label">
                    Situation familiale <strong className="text-danger">*</strong>
                </label>
                <div className="col-sm-8">
                    <select
                    className='form-select w-25'
                    id="typeFamilySituation"
                    name="typeFamilySituation"
                    onChange={(e) => {
                        setReducedIndividualPerson(initialReducedIndividualState)
                        setTypeFamilySituationData(Number(e.target.value))
                    }}
                    value={typeFamilySituationData}
                    >
                        <option value={0}>Célibataire</option>
                        <option value={1}>Pacsé</option>
                        <option value={2}>Marié</option>
                        <option value={3}>Divorcé</option>
                        <option value={4}>Veuf</option>
                    </select>
                </div>
                {
                    (typeFamilySituationData !== 0 &&
                        typeFamilySituationData !== 3 ) &&
                        <div className="mt-3">
                            <ReducedIndividualPerson
                            reducedIndividualPerson={reducedIndividualPerson}
                            checked={reducedIndividualPersonChecked}
                            changeReducedIndividualPerson={updatePerson}
                            onValidationChange={(isValid: boolean) => setReducedIndividualPersonValidity(isValid)}
                            />
                        </div>
                }
            </div>
        </div>
)}

export default FamilySituation;